/**
 * Presentation helpers for a user's authentication type — how the account
 * signs in. The value itself is resolved server-side (modules/authType.js)
 * and arrives on the user record as `authType`; these turn it into the label
 * and badge styling the admin reports use.
 */

const META = {
  local: { label: "Email & Password", icon: "fa-key", badge: "admin-badge--neutral" },
  google: { label: "Google", icon: "fa-google", badge: "admin-badge--info", brand: true },
  facebook: { label: "Facebook", icon: "fa-facebook-f", badge: "admin-badge--info", brand: true },
  unknown: { label: "Unknown", icon: "fa-circle-question", badge: "admin-badge--warning" },
};

function meta(type) {
  return META[String(type || "").toLowerCase()] || META.unknown;
}

export function authTypeLabel(type) {
  return meta(type).label;
}

export function authTypeBadgeClass(type) {
  return meta(type).badge;
}

/**
 * Font Awesome class for the type. Google/Facebook live in the brands family
 * (`fa-brands`), the rest in the solid one — returning both parts keeps the
 * callers from having to know which.
 */
export function authTypeIconClass(type) {
  const m = meta(type);
  return `${m.brand ? "fa-brands" : "fa-solid"} ${m.icon}`;
}
